/**
 * CHG-052 REQ-V52-008: 이슈 타입 스킴 관리 API 서비스
 */
import api from '../lib/axios';
import type { ApiResponse } from '@maios/shared';

export interface SchemeItem {
  id: string;
  issueType: { issueTypeId: string; name: string; icon: string; color: string; customIconPath?: string | null };
  isDefault: boolean;
  sortOrder: number;
}

export interface HierarchyRule {
  id: string;
  parentType: { issueTypeId: string; name: string; icon: string } | null;
  childType: { issueTypeId: string; name: string; icon: string };
}

export interface HierarchyTreeNode {
  type: { issueTypeId: string; name: string; icon: string; color: string };
  children: HierarchyTreeNode[];
}

export interface SchemeListItem {
  schemeId: string;
  name: string;
  description: string | null;
  isDefault: boolean;
  isSystem: boolean;
  items: SchemeItem[];
  projectCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface SchemeDetail extends SchemeListItem {
  hierarchyRules: HierarchyRule[];
  hierarchyTree: HierarchyTreeNode[];
}

export interface CreateSchemeData {
  name: string;
  description?: string;
  items: { issueTypeId: string; isDefault: boolean; sortOrder: number }[];
  hierarchyRules: { parentTypeId: string | null; childTypeId: string }[];
}

export interface UpdateSchemeData {
  name?: string;
  description?: string | null;
  items?: { issueTypeId: string; isDefault: boolean; sortOrder: number }[];
  hierarchyRules?: { parentTypeId: string | null; childTypeId: string }[];
}

export async function fetchSchemes(): Promise<SchemeListItem[]> {
  const res = await api.get<ApiResponse<{ schemes: SchemeListItem[] }>>('/admin/issue-type-schemes');
  return res.data.data!.schemes;
}

export async function fetchSchemeDetail(schemeId: string): Promise<SchemeDetail> {
  const res = await api.get<ApiResponse<SchemeDetail>>(`/admin/issue-type-schemes/${schemeId}`);
  return res.data.data!;
}

export async function createScheme(data: CreateSchemeData): Promise<SchemeDetail> {
  const res = await api.post<ApiResponse<SchemeDetail>>('/admin/issue-type-schemes', data);
  return res.data.data!;
}

export async function updateScheme(schemeId: string, data: UpdateSchemeData): Promise<SchemeDetail> {
  const res = await api.put<ApiResponse<SchemeDetail>>(`/admin/issue-type-schemes/${schemeId}`, data);
  return res.data.data!;
}

export async function deleteScheme(schemeId: string): Promise<void> {
  await api.delete(`/admin/issue-type-schemes/${schemeId}`);
}

export async function cloneScheme(schemeId: string): Promise<SchemeDetail> {
  const res = await api.post<ApiResponse<SchemeDetail>>(`/admin/issue-type-schemes/${schemeId}/clone`);
  return res.data.data!;
}
